module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/uczelnia-black-d10ef26c24641a8bf6fb311b7763f6fd.svg";